import { render, staticRenderFns } from "./ConversationToSubscribeListItem.vue?vue&type=template&id=5bf67a56&class=chat-list&"
import script from "./ConversationToSubscribeListItem.vue?vue&type=script&lang=js&"
export * from "./ConversationToSubscribeListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports